import axios from "axios";
import { environment } from "../environments/environment";
import any from "../models/usuario.model";

export const api = axios.create({
    baseURL: environment.serverUrl
});

export async function LoginService(dto: any) {
    let url = '/?apis=login-usuario';
    return await api.post(url, dto, {});
}

export async function CadastrarService(dto: any) {
    let url = '/?apis=cadastrar-usuario';
    return await api.post(url, dto, {});
}

export async function AtualizarUsuarioService(dto: any) {
    let url = '/?apis=atualizar-usuario';
    return await api.post(url, dto, {});
}

export async function EsqueciMinhaSenhaService(dto: any) {
    let url = '/?apis=esqueci-minha-senha';
    return await api.post(url, dto, {});
}